// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ijgn","newExpiryDate":"styles_newExpiryDate__Mauat","footer":"styles_footer__3mhCd"};